import { Component, OnInit, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { VesselsService } from './vessels.service';
import { FavoriteDirective } from './../shared/directives/favorite.directive';
import { BlurComponent } from './../shared/blur';
import { LogService, Voyage } from './../shared/';
import { Vessel, Voyages } from './../shared/models';

@Component({
  selector: 'vessels',
  template: require('./vessels.component.html'),
  styles: [require('./vessels.component.scss')],
  providers: [VesselsService, FavoriteDirective]
})
export class VesselsComponent implements OnInit, OnDestroy, AfterViewInit {
  voyages: Voyages = new Voyages(null);

  vessel: Vessel = new Vessel(null);

  vesselId: number;
  imo: number;
  offset: number;
  limit: number = 75;
  sub: any;
  pages: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  pageNumber: number = 1;
  paginationContext: string = '';

  thumbnailUrl: string;
  thumbnailDiv: HTMLImageElement;
  thumbnailLargeDiv: HTMLImageElement;

  sidebarActive = false;

  constructor(private logger: LogService, private service: VesselsService, private route: ActivatedRoute, private router: Router) {
    // Do stuff
  }

  @HostListener('window:resize', ['$event.target']) 
  onResize() {
    this.service.resizeSidebar();
  }

  ngOnInit() {
    this.logger.log('vessels.component', 'ngOnInit', this.route.snapshot.params);
    this.sub = this.route.params.subscribe(this.setupPage.bind(this));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  ngAfterViewInit() {
    this.service.resizeSidebar();

    // ADDED BY RM
    this.thumbnailDiv = (<HTMLImageElement>document.getElementById('vessel-thumbnail'));
    this.thumbnailLargeDiv = (<HTMLImageElement>document.getElementById('vessel-large-image'));
  }

  setupPage(params: { [key: string]: any }): void { 
    this.vesselId = +params['id'];
    this.limit = +params['limit'] || 75;
    this.offset = +params['offset'] || 0;
    this.getVoyages();
    this.getVessel();

    if (params['scroll'] != null && params['scroll'] ==='true') {
      window.scrollTo(0, 0);
    }
  }

  setupPagination() {
    this.pageNumber = Math.floor(this.offset / this.limit) + 1;
    let pageTotal = Math.ceil(this.voyages.total / this.limit);
    let newPages = [];

    if (this.pages === null) {
      this.pages = [];
    } else if (pageTotal <= 9) {
      let count = 0;
      for (let current = 1; current <= pageTotal; current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    } else if (this.pageNumber <= 5) {
      this.pages = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    } else if ((this.pageNumber > 5) && (this.pageNumber > pageTotal - 4)) {
      let count = 0;
      for (let current = pageTotal - 9; current <= pageTotal; current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    } else {
      let count = 0;
      for (let current = this.pageNumber - 5; (current < this.pageNumber + 4) && (current < pageTotal); current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    }

    if (this.pageNumber === pageTotal) {
      this.paginationContext = (this.limit * (this.pageNumber - 1) + 1)
        + ' - ' + (this.voyages.total) + ' of ' + this.voyages.total;
    } else {
      this.paginationContext = (this.limit * (this.pageNumber - 1) + 1)
        + ' - ' + (this.limit * this.pageNumber) + ' of ' + this.voyages.total;
    }
  }


  toPage(page: number) {
    if (page == this.pageNumber){
      // dont call update
      return;
    }
    this.service.loaderOff = false;
    this.offset = (page - 1) * this.limit;
    this.update();
  }

  update() {
    this.router.navigate(['/vessels', this.vesselId, {limit: this.limit, offset: this.offset}]);
  }

  getVoyages(retry = true) {
    this.service.loaderOff = false;
    let params = {
      limit: this.limit,
      offset: this.offset
    };

    this.service.getVoyages(this.vesselId, params).then(voyages => {
      this.formatVoyages(voyages);
    }).catch(ex => {
      if (ex === 403 && retry) {
        this.getVoyages(false);
      }
    });
  }

  formatVoyages(voyages: Voyages) {
    this.logger.log('vessels.component', 'formatVoyages', voyages);
    if (voyages != null) {
      voyages.accountTypeStr = this.service.app.accountType;
      this.voyages = voyages;
    }
    this.voyages.items.sort((v1, v2) => {
      if (v1.schedules[0].etd > v2.schedules[0].etd) {
        return 1;
      } else if (v1.schedules[0].etd < v2.schedules[0].etd) {
        return -1;
      } else {
        return 0;
      }
    });

    this.setupPagination();
  }

  getVessel(retry = true) {
    this.service.getVessel(this.vesselId).then(vessel => {
      this.logger.log('vessels.component', 'vessel subscribe', vessel);
      if (vessel != null) {
        this.vessel = vessel;

        if (vessel.thumbnailUrl !== "" && this.isValidHttpUrl(vessel.thumbnailUrl)){
          var modalElement = document.getElementById("thumbnailModal");
          var closeButton: HTMLElement = document.getElementsByClassName("close")[0] as HTMLElement;
          closeButton.onclick = function() {
            modalElement.style.display = "none";
          }
          // When the user clicks anywhere outside of the modal, close it
          window.onclick = function(event) {
            if (event.target == modalElement) {
              modalElement.style.display = "none";
            }
          }

          this.thumbnailDiv.src = vessel.thumbnailUrl;
          this.thumbnailLargeDiv.src = vessel.thumbnailUrl.replace('Small', 'Large');

          this.thumbnailLargeDiv.onclick = () => {
            //window.location.href = vessel.thumbnailUrl.replace('Small', 'Large');
            window.open('https://www.fleetmon.com/', '_blank')
          }

          this.thumbnailDiv.onclick = () => {
            //window.location.href = vessel.thumbnailUrl.replace('Small', 'Large');
            modalElement.style.display = "block";
          }
        } else {
          this.thumbnailDiv.setAttribute('style', 'display: none;')
        }
        
      }
    }).catch(ex => {
      if (ex === 403 && retry) {
        this.getVessel(false);
      }
    });
  }

  isValidHttpUrl(string) {
    let url;
    
    try {
      url = new URL(string);
    } catch (_) {
      return false;  
    }
  
    return url.protocol === "http:" || url.protocol === "https:";
  }

  slideOutIn() {
    this.sidebarActive = !this.sidebarActive;
  }

  registerMessage() {
      this.service.app.showRegister();
  }

  expand(item: Voyage) {
    item.viewDetails = !item.viewDetails;
    this.service.resizeSidebar();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/vessels/vessels.component.ts